import moment from "moment-timezone";

function utcToLocale(date, format) {
  if (date) return moment.utc(date).local().format(format);
  else null;
}

function localeToUTC(date) {
  return moment(date).toISOString();
}

function isUpcoming(publishDate) {
  return moment.utc(publishDate).local().isAfter(moment());
}

function isExpired(pulloutDate) {
  return moment.utc(pulloutDate).local().isBefore(moment());
}

export { isExpired, isUpcoming, localeToUTC, utcToLocale };
